<template>
	<router-link
		:to="(!isBrand) ? {name: 'product', params:{product: item.id, source: source}, query: {...$route.query, ...$route.params}} : {name:'brand', params:{brand: item.id, source: source, backRoute: $route.fullPath, backName: title}}"
		class="listItem"
	>
		<div class="imageContainer">
			<span class="imageStickerWrapper">
				<img v-if="imageUrl" :src="image" class="productImage" :style="(carousel !== undefined) ? 'height:170px;' : ''" :alt="item.title">
				<ProductSticker v-if="item.product_promotion_sticker_id_fk" :stickerId="item.product_promotion_sticker_id_fk" />
			</span>

			<div class="overlayInfo">
				<span v-if="showroomStock" class="stockImage"><img src="@/assets/img/tick.png" alt="Tick" class="stockTick">In Stock</span>
				<!--<div class="groupName" v-if="item.group_name">Available in {{item.group_size}} {{item.group_name}}s</div>-->
				<div class="groupName" v-for="(group_name)  in item.group_name_array"  v-bind:key="group_name"> {{group_name}}</div>
			</div>
			<!-- In Stock Indicator --> 
			<div v-if="$store.state.auth.loggedIn && !isBrand" class="productActions">
				<FavouritesButton :itemId="item.id"/>
				<!-- <CartButton :itemId="item.id"/> -->
			</div>
			</div>
			<div class="details">
				<div :class="(carousel !== undefined) ? 'carousel_height': ''">
				<span class="title">{{item.title}}</span>
				<span class="product_code" v-if="!isBrand"> - {{item.product_code}}</span>
				</div>
			<!-- If the price is not expired -->
			<div v-if="!item.price_expired && !isBrand" class="price_container">
				<!-- Public  -->
				<div v-if="$store.state.auth.memberLevel == 'public'">
					<span v-if="item.prices && item.prices.savings_amounts" class="price">
						<span v-if="item.prices.savings_amounts.silver > 0">Silver: {{CurrencyFormatter(item.prices.savings_amounts.silver)}} off RRP</span>
						<br>
						<span v-if="item.prices.savings_amounts.gold > 0">Gold: {{CurrencyFormatter(item.prices.savings_amounts.gold)}} off RRP</span>
						<br>
					</span>
					<router-link :to="{name:'signup'}" class="btn btn-primary signup-button mt-2">Sign up</router-link>
				</div>

				<!-- Silver Members -->
				<div v-if="$store.state.auth.memberLevel == 'silver'">
					<span v-if="item.prices && item.prices.retail" class="price rrp">RRP: {{CurrencyFormatter(item.prices.retail)}}</span>
					<span
						v-if="item.prices && item.prices.silver"
						class="price current"
					>
						Silver: {{CurrencyFormatter(item.prices.silver.price)}}
						<!-- If retail price not set in devcore, can't display savings percent, don't display if 0 or less -->
						<span
						v-if="item.prices.silver.saving_percent && item.prices.silver.saving_percent > 0"
						>- Save {{item.prices.silver.saving_percent.toFixed(1)}}%</span>
					</span>
					<span
						v-if="item.prices && item.prices.gold"
						class="price"
					>
						Gold: {{CurrencyFormatter(item.prices.gold.price)}}
						<!-- If retail price not set in devcore, can't display savings percent -->
						<span
						v-if="item.prices.gold.saving_percent && item.prices.gold.saving_percent > 0"
						>- Save {{item.prices.gold.saving_percent.toFixed(1)}}%</span>
					</span>

					<span v-if="item.prices && item.prices.gold" class="upgrade-btn">
						<router-link :to="{name:'accountGoldUpgrade'}" class="btn btn-upgrade mt-2">Upgrade to Gold Now</router-link>
					</span>
				</div>
				<!-- Gold Members -->
				<div v-if="$store.state.auth.memberLevel == 'gold'">
					<span v-if="item.prices && item.prices.retail" class="price rrp">RRP: {{CurrencyFormatter(item.prices.retail)}}</span>
					<span
						v-if="item.prices && item.prices.gold"
						class="price current"
					>
						Gold: {{CurrencyFormatter(item.prices.gold.price)}}
						<!-- If retail price not set in devcore, can't display savings percent -->
						<span
						v-if="item.prices.gold.saving_percent && item.prices.gold.saving_percent > 0"
						>- Save {{item.prices.gold.saving_percent.toFixed(1)}}%</span>
					</span>
				</div>

				<!-- Staff Member -->
				<div v-if="$store.state.auth.memberLevel == 'staff'">
					<span v-if="item.prices && item.prices.retail" class="price rrp">RRP: {{CurrencyFormatter(item.prices.retail)}}</span>
					<span
						v-if="item.prices && item.prices.staff"
						class="price current"
					>
						Staff: {{CurrencyFormatter(item.prices.staff.price)}}
						<!-- If retail price not set in devcore, can't display savings percent -->
						<span
						v-if="item.prices.staff.saving_percent && item.prices.staff.saving_percent > 0"
						>- Save {{item.prices.staff.saving_percent.toFixed(1)}}%</span>
					</span>
				</div>

				<!-- Platinum Members -->
				<span
				v-if="item.prices && item.prices.platinum && $store.state.auth.memberLevel == 'platinum'"
				class="price"
				>Platinum {{item.prices.platinum.price}}</span>
			</div>
		</div>
	</router-link>
</template>

<script>
import { imageUrl } from "@/utils";

import FavouritesButton from "@/components/buttons/FavouritesButton";
import ProductSticker from "@/components/ProductSticker"

import { CurrencyFormatter } from "@/utils";

import { mapGetters } from "vuex"

export default {
	name: "productListItem",

	components: {
		FavouritesButton,
		ProductSticker
	},
	props: ["item", "carousel", "source"],
	computed: {
		...mapGetters({
			// map categories to store.reference.categories
			categories: "reference/categoriesMap"

		}),
		image() {
		//console.log(this.item)
			let url = "/resources/images/content/default-image-3.png";
			if (this.item.images && this.item.images[0]) {
				url = imageUrl(this.item.images[0].sizes, "thumbnail");
			}

			return url;
		},
		showroomStock() {
			if(this.item.stock_available) {
				return this.item.stock_available.indexOf("Wellington Showroom") > -1;
			}
			return false;
		},
		stockImage() {
			return "/resources/images/ui/stock-sticker.png";
		},
		isBrand() {
			return this.item.product_code.toLowerCase().includes("_info");
		},
		title() {
			let subcat = this.$route.params.subcategory
			if (subcat) {
				return this.categories[subcat].category
			}
			return "Search"
		}
	},
	methods: {
		imageUrl,
		CurrencyFormatter
	}
};
</script>

<style lang="scss" scoped>
.listItem {
	display: block;
	flex-direction: column;
	justify-content: space-between;

	background: white;

	//   text-align: center;
	padding: 10px;
	min-height: 100%;
	margin: 10px 0;
	&:hover {
		text-decoration: none;
	}

	.signup-button{
		font-size:0.8em;
		margin: 0 auto;
		width: 100px;
		display: block;
	}

	.details {
			display: inline-block;
			vertical-align: top;
			width: 100%;
		.title {
			font-size: 0.9em;
			color: $CTred;
			font-weight: bold;
		}
		.product_code{
			font-size:0.9em;
			color:$CTred;
			font-weight:bold;
		}
		.rrp {
			color: darkgrey;
			font-size: 0.8em;
		}
		.carousel_height{
			height: 9em;
		}
	}

	.upgrade-btn {
		width: 100%;
		display: block;
		text-align: center;
	}

	.price {
		display: block;
		color: black;
		text-decoration: none;

		&.current {
			font-weight: bold;	display: block;
		}
	}
	.imageContainer {
		position: relative;
		text-align: center;

		img {
			max-width: 100%;
			object-fit: contain;
			flex-grow: 1;
		}

		.productActions {
			position: absolute;
			top: 0;
			right: 0;
		}

		
	}
}

@include media-breakpoint-down(sm){
  .carousel_height{
    height: 4em !important;
  }
}

@include media-breakpoint-down(md){
  .carousel_height{
    height: 6em;
  }
}

@include media-breakpoint-up(xl){
  .carousel_height{
    height: 7em !important;
  }
}

.overlayInfo {
	width: 100%;
	position: absolute;
	// display: block;
	left: 0;
	padding-top: 2px;
	// top: 0;
	bottom: 0;
	background: rgba(255,255,255,0.8);
	text-align: left;
	.stockImage {
		color: $CTgreen;
		font-weight: bold;
		img {
			margin: 0 5px;
		}
	}

	.groupName{
		// position:absolute;
		bottom:0;
		left:0;
		right:0;
		// padding:5px;
		text-align:center;
		// background:rgba(255,255,255,0.8);
	}
}

.imageStickerWrapper {
	display: inline-block;
	position: relative;
}
</style>
